module.exports = __webpack_public_path__ + "media/images/sale_crm/invoice-35b65ff7e397f6e7de1a4d3225434eac.svg";